import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

import "../scss/components/_slider-reviews.scss";

const initReviews = () => {
  const sliderReviews = $Q('.reviews');

  if (!sliderReviews) return;

  const reviewsQta = parseInt(sliderReviews.dataset.qta);

  new Swiper(sliderReviews, {
    modules: [Pagination, Navigation],
    // autoHeight: true,
    slidesPerView: 4,
    breakpoints: {
      280: {
        slidesPerView: 1.3,
      },
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      }
    },
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next' || null,
      prevEl: '.swiper-button-prev' || null,
    },
    autoplay: false
  });

  /*if( reviewsQta < 5 ){
    const reviews__container = $Q('.reviews__container');
    const swiper_button_next = $Q('.swiper-button-next', reviews__container);
    const swiper_button_prev = $Q('.swiper-button-prev', reviews__container);
    swiper_button_next.style.display = "none";
    swiper_button_prev.style.display = "none";
  }*/

};

export default initReviews;
